import "leaflet/dist/leaflet.css";
import { useEffect } from "react";
import { MapContainer, TileLayer, CircleMarker, Tooltip, useMap, useMapEvents } from "react-leaflet";

const Fit = ({ points, origin, selected }) => {
  const map = useMap();
  const key = points.map((p) => `${p.latitude},${p.longitude}`).join("|") + (origin ? `o${origin.latitude},${origin.longitude}` : "");
  useEffect(() => {
    const t = setTimeout(() => {
      map.invalidateSize();
      const coords = points.map((p) => [p.latitude, p.longitude]);
      if (origin) { coords.push([origin.latitude, origin.longitude]); }
      if (coords.length === 1) { map.setView(coords[0], 14); }
      else if (coords.length > 1) { map.fitBounds(coords, { padding: [40, 40], maxZoom: 15 }); }
    }, 60);
    return () => clearTimeout(t);
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (selected) { map.flyTo([selected.latitude, selected.longitude], Math.max(map.getZoom(), 14), { duration: 0.6 }); }
  }, [selected?.id]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
};

const ClickPick = ({ onPick }) => {
  useMapEvents({ click: (e) => onPick({ latitude: +e.latlng.lat.toFixed(6), longitude: +e.latlng.lng.toFixed(6) }) });
  return null;
};

export function MapView({ points = [], origin, selectedId, onSelect, onPick, className = "h-[460px]", testId = "directory-map" }) {
  const selected = points.find((p) => p.id === selectedId);
  return (
    <div className={`relative overflow-hidden rounded-xl border border-slate-200 ${className}`} data-testid={testId}>
      <MapContainer center={[12, 5]} zoom={2} scrollWheelZoom className="h-full w-full" worldCopyJump>
        <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <Fit points={points} origin={origin} selected={selected} />
        {onPick && <ClickPick onPick={onPick} />}
        {origin && (
          <CircleMarker center={[origin.latitude, origin.longitude]} radius={7} pathOptions={{ color: "#0f172a", fillColor: "#0f172a", fillOpacity: 0.9 }}>
            <Tooltip>Votre position</Tooltip>
          </CircleMarker>
        )}
        {points.map((p) => (
          <CircleMarker key={p.id} center={[p.latitude, p.longitude]} radius={p.id === selectedId ? 12 : 9}
            pathOptions={{ color: "#ffffff", weight: 2, fillColor: p.id === selectedId ? "#e11d48" : "#1d4ed8", fillOpacity: 0.95 }}
            eventHandlers={onSelect ? { click: () => onSelect(p.id) } : {}}>
            {p.name && <Tooltip>{p.name}{p.company ? ` · ${p.company.name}` : ""}</Tooltip>}
          </CircleMarker>
        ))}
      </MapContainer>
    </div>
  );
}
